import React, { useState, useEffect } from "react";
import { Col, Modal, Nav, Row, Tab, Image, Button } from "react-bootstrap";
import Card from "../../../components/card/Card";
import LearningModulesEdit from "../admin/LearningModulesEdit";
import LearningModulesModal from "../modal/LearningModulesModal";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetLearningModule,
  selectLearningModule,
} from "../../../features/learning/learningModuleSlice";
import {
  GetCounsellorModule,
  selectCounsellorModule,
} from "../../../features/learning/CounsellorSlice";
import Dots from "../../../assets/images/la-dots.svg";
import EthicsCounsellorEdit from "../admin/EthicsCounsellorEdit";
import Feedback from "../../../components/feedbackNote/Feedback";
import { isPermited } from "../../../features/localStorage";
import { useParams } from "react-router-dom";

const title: String = "Learning Modules";
const title2: String = "Ethics Counsellor Learning Program";

const LearningModules = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const { categoryId }: any = params || "";

  const LearingModule = useAppSelector(selectLearningModule);
  const CounsellorModule = useAppSelector(selectCounsellorModule);

  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);

  useEffect(() => {
    let payloadLearningModules = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    async function fetchLearningModuleData() {
      let sample = await dispatch(GetLearningModule(payloadLearningModules));
    }

    let payloadCounseller = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    async function fetchConsellerModuleData() {
      let sample = await dispatch(GetCounsellorModule(payloadCounseller));
    }
    fetchLearningModuleData();
    fetchConsellerModuleData();
  }, []);
  const rowLearnArrayData = LearingModule?.slice(0, 4);
  const Learnlist: any = rowLearnArrayData;

  const rowConsellArrayData = CounsellorModule?.slice(0, 4);
  const consellList: any = rowConsellArrayData;
  const fetchLearningModuleData = () => {
    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    dispatch(GetLearningModule(data));
    dispatch(GetCounsellorModule(data));
  };
  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <Card
          type={1}
          title={title}
          data={Learnlist}
          fetchLearningModuleData={fetchLearningModuleData}
          modal={
            <>
              <LearningModulesEdit data={LearingModule} />
            </>
          }
        />

        {/* {!categoryId && isPermited(2, 1) && (
          <Card
            type={2}
            title={title2}
            data={consellList}
            fetchLearningModuleData={fetchLearningModuleData}
            modal={
              <>
                <EthicsCounsellorEdit data={CounsellorModule} />
              </>
            }
          />
        )} */}
      </div>
    </>
  );
};

export default LearningModules;
